<template>

  <div class="header">
    <section>
      <!-- <div class="breadcrump">
        <template v-for="(crump, index) of breadcrumps" :key="index" >
          <template v-if="index != breadcrumps.length - 1">
            <router-link :to="crump.path">{{crump.name}}</router-link>
          </template>
</template>
</div> -->
      <div class="page-title" :badge="badge">{{ breadcrumps.at(-1)?.name ?? 'Welcome' }}</div>
      <section class="menu">
        <button v-for="(sub, index) in appMenu" :key="index" @click="handleSwitchChange(sub.key)" class="item"
          :class="[sub.class, { active: sub.key === getActiveKey() }]">
          <svg class="icon">
            <use :xlink:href="require('@/assets/images/sprites/common-sprite.svg') + sub.icon"></use>
          </svg>
          <span class="name" v-html="sub.name"></span>
        </button>
      </section>
    </section>

    <!-- subdomainler arasın geçiş için menü -->
    <div class="nav-container">
      <!-- menu typelist -->
      <!-- <section class="app-menu">
        <a v-for="(sub, index) in appMenu" :key="index" :href="sub.path" target="_blank" rel="noopener" class="item"
          :class="[sub.class, { active: sub.key === getActiveKey() }]">
          <svg class="icon">
            <use :xlink:href="require('@/assets/images/sprites/common-sprite.svg') + sub.icon"></use>
          </svg>
          <span class="name" v-html="sub.name"></span>
        </a>
      </section> -->

      <!-- menu typelist -->
      <section class="nav" :class="{ active: menuIsShow }">
        <div class="item">
          <svg class="search" @click="$router.go(0);">
            <use xlink:href="@/assets/images/sprites/common-sprite.svg#search-icon"></use>
          </svg>
        </div>
        <div class="item">
          <svg class="notification" @click="toggleMenu('notification')">
            <use xlink:href="@/assets/images/sprites/common-sprite.svg#notification-icon"></use>
          </svg>
        </div>
        <div class="item">
          <div class="user" @click="toggleMenu('profile')">
            <photo-viewer class="photo" v-if="user.photo" :source="user.photo" />
            <span v-else>{{ getUserPhotoPlaceholder() }}</span>
          </div>
        </div>
        <div class="item">
          <svg class="logout" @click="logout">
            <use xlink:href="@/assets/images/sprites/common-sprite.svg#logout-icon"></use>
          </svg>
        </div>

        <template v-for="(menu, index) in menus" :key="index">
          <template v-if="menu.show">
            <div class="toggle-menu" :class="{ 'closing': !menu.show }">
              <component :is="menu.component" @close="toggleMenu(menu.type)" />
            </div>
          </template>
        </template>
      </section>
    </div>

  </div>

  <div class="overlay" v-if="menuIsShow"></div>

  <alert-message class="alert" v-if="alertMessage.messages" :type="alertMessage.type" :title="alertMessage.title"
    :messages="alertMessage.messages" />

</template>

<script lang="ts">
import { markRaw } from "vue";
import { Options, Vue } from "vue-class-component";
import Notification from "@/components/shared/Notification.vue";
import Profile from "@/components/shared/Profile.vue";
import AlertMessage from "./AlertMessage.vue";
import { User } from "@/models/commons/user";
import PhotoViewer from "./PhotoViever.vue";


@Options({
  components: {
    'alert-message': AlertMessage,
    'photo-viewer': PhotoViewer
  },
  computed: {
    breadcrumps() {
      return this.$route.matched
        .filter((route) => { return route.path != '/' && route.meta.title })
        .map((route) => { return { path: route.path, name: route.meta.title } })
    },
    badge() { return this.$route.meta.badge ?? null; },
    alertMessage() { return this.$store.state.alertMessage },
    user(): User { return new User(this.$store.state.user) },
    getActiveMenu(): boolean {
      return this.getActiveKey() == 'app' ? false : true;
    },
  },
  methods: {
    getUserPhotoPlaceholder(): string {
      if (!this.user.id) return '';
      return (this.user.first_name[0] + this.user.last_name[0]).toUpperCase();
    },
    logout() {
      this.$router.push('/login');
      this.$store.dispatch('clearStorage');
    },
    getBadgeValue() {
      if (this.$route.path.includes('/shipments/new')) return 'New';
      return null;
    },
    toggleMenu(type: string) {
      if (!type) return;
      const menu = this.menus.find((item: menu) => item.type == type);
      if (!menu) return;
      menu.show = !menu.show;
      this.menuIsShow = !this.menuIsShow;
    },
    getActiveKey(): string {
      const currentHost = window.location.hostname;
      if (currentHost.includes('app')) return 'app';
      if (currentHost.includes('wms')) return 'wms';
      return '';
    },
    handleSwitchChange(key: string) {

      if (key == this.activeMenu) return;
      console.log(this.getActiveKey());

      if (this.getActiveKey() == 'app') {
        // this.activeMenu = 'wms';
        setTimeout(() => {
          window.open(this.isLocal ? 'https://wms.logictics.local:8080/' : 'https://wms.logictics.co', "_blank");
        }, 200);
      }
      if (this.getActiveKey() == 'wms') {
        // this.activeMenu = 'app';
        setTimeout(() => {
          window.open(this.isLocal ? 'https://app.logictics.local:8080/' : 'https://app.logictics.co', "_blank");
        }, 200);
      }
    }
  }
})

export default class Headbar extends Vue {
  breadcrumps!: crump[];
  badge!: string;
  logout!: any;
  getBadgeValue!: any;
  getUserPhotoPlaceholder!: any;
  alertMessage!: AlertMessage;
  user!: User;

  toggleMenu!: any;
  getActiveKey!: any;
  menus!: menu[];
  menuIsShow!: boolean;
  isLocal!: boolean;
  appMenu!: appMenu[];

  data() {
    this.isLocal = window.location.hostname.includes('local');

    return {
      menuIsShow: false,
      menus: [
        { type: 'notification', show: false, component: markRaw(Notification) },
        { type: 'profile', show: false, component: markRaw(Profile) }
      ],
      appMenu: [
        { key: 'app', value: 'Ocean', name: 'Ocean', path: this.isLocal ? 'https://app.logictics.local:8080/' : 'https://app.logictics.co', icon: '#ocean-icon', class: 'logictics' },
        { key: 'wms', value: 'WMS', name: 'WMS', path: this.isLocal ? 'https://wms.logictics.local:8080/' : 'https://wms.logictics.co', icon: '#wms-icon', class: 'warehouse' },
      ],
      activeMenu: this.getActiveKey(),

    }
  }

}

export interface crump { path: string, name: string, badge: string }
export interface menu { type: string, show: boolean, component: any }
export interface appMenu { key: string, value: string, name: string, path: string, icon: string, class: string }
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px);
  z-index: 98;
  overflow-y: auto;
  animation: blur ease .5s forwards;
}

.header {
  display: flex;
  position: relative;
  padding: 20px 40px;
  z-index: 99;

  section {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
  }

  .breadcrump {
    display: flex;
    gap: 2px;

    * {
      position: relative;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: var(--neutral600);
      text-decoration: none;
    }
  }

  .page-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: var(--neutral800);

    &[badge]::after {
      content: attr(badge);
      font-weight: 400;
      font-size: 10px;
      line-height: 15px;
      color: var(--primary600);
      background-color: var(--neutral100);
      border: 1px solid var(--primary200);
      padding: 2px 6px;
      border-radius: 3px;
    }
  }

  .nav-container {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
}

/* .header:after {
  content: "";
  position: absolute;
  width: calc(100% - 80px);
  height: 10px;
  top: 100%;
  left: 40px;
  background: linear-gradient(to bottom, #F4F7FE, transparent);
} */

/* app-menu */
// .app-menu {
//   position: relative;
//   flex-direction: row !important;
//   align-items: center;
//   margin-left: auto;
//   height: 50px !important;
//   border-radius: 25px;

//   /* padding: 0 20px; */
//   background-color: var(--white);
//   stroke: var(--neutral700);
//   border: 1px solid transparent;
//   box-shadow: 0px 0px 20px -5px rgba(65, 76, 102, 0.25);
//   transition: all .25s;
//   display: flex;
//   overflow: hidden;
//   gap: 0 !important;

//   &.switch {
//     padding: 0 10px;
//     gap: 5px !important;
//     display: flex;
//     justify-content: center;
//     align-items: center;

//     .name.active {
//       color: var(--primary600);
//     }
//   }

//   &.no-border {
//     background-color: transparent;
//     box-shadow: none;
//     border: none;
//   }

//   .item {
//     padding: 10px;
//     gap: 10px;
//     display: flex;
//     align-items: center;
//     transition: all .25s;
//     text-decoration: none;
//     height: 100%;
//     width: 120px;

//     &.no-width {
//       width: auto;
//     }
//   }

//   :deep(.button-names) {
//     border-radius: 25px;
//     overflow: hidden;
//   }

//   :deep(.button-name) {
//     font-size: 10px !important;
//     font-weight: 600 !important;
//     line-height: 12px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     flex-direction: row-reverse;
//     gap: 5px;

//     /* border: 1px solid var(--primary600); */
//     border: 1px solid var(--neutral200);
//     width: 120px !important;
//   }

//   :deep(li:last-child .button-name) {
//     border-top-right-radius: 25px;
//     border-bottom-right-radius: 25px;
//   }

//   :deep(li:first-child .button-name) {
//     border-top-left-radius: 25px;
//     border-bottom-left-radius: 25px;
//   }

//   .item {
//     &:first-child {
//       padding-left: 15px;
//     }

//     &:last-child {
//       padding-right: 15px;
//     }

//     &.active {
//       background-color: var(--primary100);
//       pointer-events: none;
//     }

//     svg {
//       position: relative;
//       width: 22px;
//       height: 22px;
//       min-width: 22px;
//       min-height: 22px;
//       cursor: pointer;
//       transition: all ease-in-out .25s;
//       color: #414C66;
//     }
//   }

//   .name {
//     font-weight: bold;
//     font-size: 10px;
//     line-height: 12px;
//     color: var(--neutral600);
//   }

//   .item:hover .name {
//     color: var(--primary600);
//   }
// }

.menu {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px !important;

  .item {
    height: 42px;
    padding: 0 1rem;
    gap: 5px !important;
    display: flex;
    align-items: center;
    background-color: var(--white);
    border-radius: 2rem;
    font-size: 14px;
    font-weight: 500;
    color: #202124;
    line-height: 12px;
    display: flex;
    gap: 0.5rem !important;
    border: 1px solid #dadce0;
    transition: 150ms all;

    font-family: "Google Sans", Roboto, Arial, sans-serif;
    font-size: .875rem;
    letter-spacing: .0107142857em;
    font-weight: 500;
    text-transform: none;

    &:hover {
      text-decoration: none;
      color: var(--primary600);
      background-color: rgba(0,0,0, 0.01);

    }

    svg.icon {
      width: 16px;
      height: 16px;
      color: var(--primary600);
    }

    .name {}

    &.active {
      color: #1967d2;
      // background-color: var(--primary100);
      background-color: #e8f0fe;
      border: none;
    }
  }

}

.header {
  .nav {
    position: relative;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    /* margin-left: auto; */
    height: 50px;
    border-radius: 25px;
    padding: 0 20px;
    background-color: var(--white);
    stroke: var(--neutral700);
    border: 1px solid transparent;
    box-shadow: 0px 0px 20px -5px rgba(65, 76, 102, 0.25);
    transition: all .25s;

    &.active {
      border: 1px solid var(--neutralCadetBlueCrayola);
    }

    svg {
      position: relative;
      width: 22px;
      height: 22px;
      cursor: pointer;
      transition: all ease-in-out .25s;
    }

    .user {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      border: 1px solid var(--success600);
      background-color: var(--neutral100);
      font-size: 10px;
      cursor: pointer;

      &::after {
        position: absolute;
        content: '';
        right: -1px;
        bottom: -1px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: var(--success600);
      }

      .photo {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        border-radius: 50%;
        background-color: var(--white);
        overflow: hidden;
      }
    }

    svg:hover,
    .active svg {
      stroke: var(--primary600);
    }
  }

  .app-menu .item {

    &:hover svg,
    &.active svg,
    &:hover .name,
    &.active .name {
      color: var(--primary600);
    }
  }

  .toggle-menu {
    position: absolute;
    right: 0;
    top: calc(100% + 10px);
    background-color: var(--white);
    border-radius: 10px;
    border: 1px solid var(--neutralCadetBlueCrayola);
    box-shadow: 0px 0px 20px -5px rgba(65, 76, 102, 0.25);
    overflow: hidden;
    z-index: 1;
  }
}

.alert {
  margin: 5px 40px;
}

@media screen and (max-width: 800px) {
  .header {
    padding: 10px;
    transition: all ease-in-out .25s;
  }
}
</style>


<!-- <style scoped>
.type-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
}

.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.buttons button {
  width: 20px;
  height: 10px;
}
</style> -->
